import { ListFilter, ListFilterModel } from "../filter.model";

export class DropdownModel {
    value!: string | number;
    name!: string;
}

export class DropdownApiResponseModel {
    id!: number;
    name!: string;
}

export interface BooleanDropdownModel {
    value: boolean | null;
    name: string;
}

/**
 * Parent-Child Dropdown Interface
 * Represents hierarchical dropdown structure with parent-child relationships
 */
export interface ParentChildDropdown {
    id: string;
    name: string;
    childCategories: ParentChildDropdown[];
}

/**
 * Dropdown Filter Model
 * Encapsulates dropdown filter state
 */
export class DropdownFilterModel extends ListFilterModel {
    constructor(model: ListFilter = {}) {
        super(model);
    }
}
